import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const authSelector = (state: RootState) => state.company;

export const getCompany = createSelector(
  authSelector,
  (company) => company.company,
);

export const getCompanyLogin = createSelector(
  authSelector,
  (company) => company.companyLogin,
);
